import { createSlice } from "@reduxjs/toolkit"

// create slice
const loginInfo = createSlice({
  name: "loginInfo",
  initialState: {
    // email: "rtk default username",
    // password: "rtk default password"
    username: "",
    token: "",
    mfaToken: "",
    firstName: "",
    lastName: "",
    lastLoginDate: "",
    psoId: "",
    psoName: "",
    lastValidity: null
  },
  reducers: {
    setUsername (state, action) {
      state.username = action.payload
    },
    setToken (state, action) {
      state.token = action.payload
    },
    setMfaToken (state, action) {
      state.mfaToken = action.payload
    },
    setFirstName (state, action) {
      state.firstName = action.payload
    },
    setLastName (state, action) {
      state.lastName = action.payload
    },
    setLastLoginDate (state, action) {
      state.lastLoginDate = action.payload
    },
    setPsoId (state, action) {
      state.psoId = action.payload
    },
    setPsoName (state, action) {
      state.psoName = action.payload
    },
    setLastValidity (state, action) {
      state.lastValidity = action.payload
    },

    setRole (state, action) {
      state.role = action.payload
    },

    clearFields (state, action) {
      state.username = "";
      state.token = "";
      state.firstName = "";
      state.lastName = "";
      state.lastLoginDate = "";
      state.psoId = "";
      state.psoName = "";
      state.role = "";
    }
  }
})
// action: {type: name/functionName, payLoad: param}
export const { setUsername, setToken, setMfaToken, setFirstName, setLastName, setLastLoginDate, setPsoId, setPsoName, setLastValidity, setRole, clearFields } = loginInfo.actions
export default loginInfo.reducer